<template>
    <div class="text-md-left shop-bank-info-modal">
        <el-form :model="data.shopDetail" :rules="rules" ref="shopBankInfo" label-width="220px" label-position="left">
            <el-row :gutter="20">
                <el-col :span="12">
                <el-form-item label="ประเภทบัญชี" prop="bankAccountType">
                    <el-select v-model="data.shopDetail.bankAccountType">
                        <el-option v-for="item in bankAccountTypeList" :key="item.id" :label="item.label" :value="item.id"></el-option>
                    </el-select>
                </el-form-item>
            </el-col>
                <el-col :span="12">
                    <el-form-item label="ชื่อนิติบุคคล" prop="legalName" v-if="data.shopDetail.bankAccountType === 1">
                        <el-input v-model="data.shopDetail.legalName"></el-input>
                    </el-form-item>
                </el-col>
            </el-row>

            <el-form-item label="เลขประจำตัวผู้เสียภาษี" prop="taxId">
                <el-input v-model="data.shopDetail.taxId"></el-input>
            </el-form-item>
            <el-form-item label="อีเมล์สำหรับบัญชี" prop="bankAccountEmail">
                <el-input v-model="data.shopDetail.bankAccountEmail"></el-input>
            </el-form-item>
                <el-form-item label="ที่อยู่ทางบัญชี" prop="bankAccountAddress">
                <el-input v-model="data.shopDetail.bankAccountAddress"></el-input>
            </el-form-item>
            <address-system
                            ref="formBankAddress"
                            :address="bankAddress"
                            :isSubmitForm="isSubmitForm"
                            :isCancel="isCancel"
                            @updated:address="updateBankAddress($event)"
                            @onCancel="(value)=>$emit('onCancel', value)" />
            <!-- <ZipcodeSystem
                ref="zipcode-system-bank"
                class="zipcode-system-bank"
                layout="square"
                :province="bankAddress.province"
                :district="bankAddress.district"
                :envelopment="$store.get('envSystem/mode')"
                :sub-district="bankAddress.subDistrict"
                :zipcode="bankAddress.zipcode"
                @onCompleteAddress="updateBankAddress($event)"
            /> -->
            <!-- <helper-province :info.sync="data.shopDetail"
            :provincearray="provinceArray"
            :name="nameProvince"
            :geo="geoHierarchyData" /> -->
            <hr style="margin-bottom:20px;color:black;">
            <el-form-item label="ชื่อบัญชี" prop="bankAccountName">
                <el-input v-model="data.shopDetail.bankAccountName"></el-input>
            </el-form-item>
            <el-form-item label="หมายเลขบัญชีธนาคาร" prop="bankAccountNumber">
                <el-input v-model="data.shopDetail.bankAccountNumber"></el-input>
            </el-form-item>
            <el-form-item label="บัญชีธนาคาร" prop="bankName">
                <el-select v-model="data.shopDetail.bankName" placeholder="กรุณาเลือกธนาคาร">
                    <el-option :label="item.label" v-for="item in bankTypelist" :key="item.id" :value="item.id">
                        <span style="float: left"><img :src="item.logoPath" style="width:32px;" /></span>
                        <span style="float: right; color: black; font-size: 14px">{{ item.label }}</span>
                    </el-option>
                </el-select>
            </el-form-item>
            </el-form>
            <hr>
            <el-row :gutter="20">
                <el-col :span="8" class="text-center">
                    <span style="font-size:18px;">รูปบัตรประชาชน</span>
                        <div class="block image-loading-shop-bank-info" style="margin-top:5px;">
                            <el-image :src="imageData.identify_card" :preview-src-list="imageListPreview.identify_card" style="height: 250px;width: 280px;"></el-image>
                        </div>
                    <el-upload
                        action="#"
                        :on-change="uploadIdentifyCard"
                        :auto-upload="false"
                        :show-file-list="false">
                         <el-button size="small" type="primary">Click to upload</el-button>
                    </el-upload>
                </el-col>
                <el-col :span="8" class="text-center">
                    <span style="font-size:18px;"> รูปหน้า Book Bank</span>
                    <div class="block image-loading-shop-bank-info1" style="margin-top:5px;">
                        <el-image :src="imageData.bank_book_account" :preview-src-list="imageListPreview.bank_book_account" style="height: 250px;width: 280px;"></el-image>
                    </div>
                    <el-upload
                        action="#"
                        :on-change="uploadBookBank"
                        :auto-upload="false"
                        :show-file-list="false">
                         <el-button size="small" type="primary">Click to upload</el-button>
                    </el-upload>
                </el-col>
                <el-col :span="8" class="text-center">
                    <span style="font-size:18px;">หนังสือรับรองนิติบุคคล</span>
                    <div class="block image-loading-shop-bank-info2" style="margin-top:5px;">
                        <el-image :src="imageData.vat_company" :preview-src-list="imageListPreview.vat_company" style="height: 250px;width: 280px;"></el-image>
                    </div>
                    <el-upload
                        action="#"
                        :on-change="uploadVat"
                        :auto-upload="false"
                        :show-file-list="false">
                         <el-button size="small" type="primary">Click to upload</el-button>
                    </el-upload>
                </el-col>
            </el-row>

    </div>
</template>

<script>
// import fgApi from '@/services/fillgoods'
// import ZipcodeSystem from '@bit/fillgoodscompany.fg-component.zipcode-system'
import AddressSystem from '@/components/address/AddressSystem.vue'
// import helperProvince from '@/components/helper/BaseProvinceSelectShopBank'
export default {
    name: 'shopBankInfoForm',
    components: {
        // helperProvince
        // ZipcodeSystem,
        'address-system': AddressSystem
    },
    props: {
        data: {
            type: Object,
            default: null
        },
        provinceArray: {
            type: Array,
            default: null
        },
        geoHierarchyData: {
            type: Object,
            default: null
        },
        isSubmitForm: {
            type: Boolean,
            deault: false
        },
        isCancel: {
            type: Boolean,
            deault: false
        }
    },
    data () {
        return {
            // nameProvince: {
            //     provi: 'bankAccountProvince',
            //     distr: 'bankAccountDistrict',
            //     subDist: 'bankAccountSubDistrict'
            // },
            // imageUrl: '',
            imageData: {
                bank_book_account: '',
                identify_card: '',
                vat_company: ''
            },
            imageListPreview: {
                bank_book_account: [],
                identify_card: [],
                vat_company: []
            },
            bankAddress: {
                province: '',
                district: '',
                subDistrict: '',
                zipcode: '' }
        }
    },
    computed: {
        rules () {
            if (this.data.shopDetail.bankAccountType === 1) {
                return {
                    bankAccountName: [{ required: true, message: 'กรุณากรอกชื่อบัญชี', trigger: 'blur' }],
                    taxId: [{ required: true, message: 'กรุณากรอกเลขประจำตัวผู้เสียภาษี', trigger: 'blur' }],
                    legalName: [{ required: true, message: 'กรุณากรอกชื่อนิติบุคคล', trigger: 'blur' }],
                    bankAccountEmail: [
                        { required: true, message: 'กรุณากรอกชื่ออีเมลสำหรับส่งบัญชี', trigger: 'blur' },
                        { type: 'email', message: 'กรุณาตรวจสอบรูปแบบอีเมล', trigger: ['blur', 'change'] }
                    ],
                    bankAccountAddress: [{ required: true, message: 'กรุณากรอกที่อยู่ทางบัญชี', trigger: 'blur' }],
                    bankAccountSubDistrict: [{ required: true, message: 'กรุณากรอกตำบล', trigger: 'change' }],
                    bankAccountDistrict: [{ required: true, message: 'กรุณากรอกอำเภอ', trigger: 'change' }],
                    bankAccountProvince: [{ required: true, message: 'กรุณากรอกจังหวัด', trigger: 'change' }],
                    bankAccountZipcode: [{ required: true, message: 'กรุณากรอกรหัสไปรษณีย์ร้านค้า', trigger: 'blur' }],
                    bankAccountNumber: [{ required: true, message: 'กรุณากรอกหมายเลขบัญชีธนาคาร', trigger: 'blur' }],
                    bankName: [{ required: true, message: 'กรุณาเลือกธนาคาร', trigger: 'change' }]
                }
            } else {
                return {
                    bankAccountName: [{ required: true, message: 'กรุณากรอกชื่อบัญชี', trigger: 'blur' }],
                    taxId: [{ required: true, message: 'กรุณากรอกเลขประจำตัวผู้เสียภาษี', trigger: 'blur' }],
                    bankAccountEmail: [
                        { required: true, message: 'กรุณากรอกชื่ออีเมลสำหรับส่งบัญชี', trigger: 'blur' },
                        { type: 'email', message: 'กรุณาตรวจสอบรูปแบบอีเมล', trigger: ['blur', 'change'] }
                    ],
                    bankAccountAddress: [{ required: true, message: 'กรุณากรอกที่อยู่ทางบัญชี', trigger: 'blur' }],
                    bankAccountSubDistrict: [{ required: true, message: 'กรุณากรอกตำบล', trigger: 'change' }],
                    bankAccountDistrict: [{ required: true, message: 'กรุณากรอกอำเภอ', trigger: 'change' }],
                    bankAccountProvince: [{ required: true, message: 'กรุณากรอกจังหวัด', trigger: 'change' }],
                    bankAccountZipcode: [{ required: true, message: 'กรุณากรอกรหัสไปรษณีย์ร้านค้า', trigger: 'blur' }],
                    bankAccountNumber: [{ required: true, message: 'กรุณากรอกหมายเลขบัญชีธนาคาร', trigger: 'blur' }],
                    bankName: [{ required: true, message: 'กรุณาเลือกธนาคาร', trigger: 'change' }]
                }
            }
        }
    },
    watch: {
        'data.dialogVisible': {
            immediate: true,
            handler (val) {
                if (val) {
                    this.bankAddress.province = this.data.shopDetail.bankAccountProvince
                    this.bankAddress.district = this.data.shopDetail.bankAccountDistrict
                    this.bankAddress.subDistrict = this.data.shopDetail.bankAccountSubDistrict
                    this.bankAddress.zipcode = this.data.shopDetail.bankAccountZipcode
                } else {
                    this.bankAddress.province = ''
                    this.bankAddress.district = ''
                    this.bankAddress.subDistrict = ''
                    this.bankAddress.zipcode = ''
                    // if (this.$refs['zipcode-system-bank']) { this.$refs['zipcode-system-bank'].$v.$reset() } **
                }
            }
        }
    },
    mounted () {
        if (!this.data.imageDetail.checkFetch) {
            this.getUrlImage()
        }
    },
    created () {
        if (this.data.imageDetail.checkFetch) {
            // console.log(this.data.imageDetail)
            this.imageData = this.data.imageDetail.imageData
            this.imageListPreview = this.data.imageDetail.imageListPreview
            // console.log(this.imageData)
        }
    },
    methods: {
        async getCollectionLastData (param) {
            this.$loading()
            const env = (mode) => {
                if (mode === 'production') {
                    return 'prod'
                } else {
                    return mode
                }
            }
            let storageRef = this.$store.get('fgFirbaseApp/' + env(this.$store.get('envSystem/mode'))).firestore()

            let collect = await storageRef.collection(param.path).orderBy('version', 'desc').limit(1).get()
            let data = {}
            for (const doc of collect.docs) {
                data = doc.data()
            }
            // console.log(data)
            this.$loading().close()
            const isEmpty = (obj) => {
                for (var key in obj) {
                    if (obj.hasOwnProperty(key)) { return true }
                }
                return false
            }
            let paramUpload = {}
            if (isEmpty(data)) {
                let version = Number(data.version) + 1
                // console.log(version)
                paramUpload = {
                    customer_id: this.data.shopDetail.userId,
                    url: null,
                    imamge_path: `${param.path}/customer_${param.type}_${version}`,
                    type: param.type,
                    version: version,
                    time_created: null
                }
            } else {
                let version = 1
                paramUpload = {
                    customer_id: this.data.shopDetail.userId,
                    url: null,
                    imamge_path: `${param.path}/customer_${param.type}_${version}`,
                    type: param.type,
                    version: version,
                    time_created: null
                }
            }
            return paramUpload
        },
        async uploadIdentifyCard  (file) {
            var allowImageType = ['image/jpeg', 'image/jpg', 'image/png', 'image/gif', 'image/bmp']
            if (allowImageType.indexOf(file.raw.type) > -1) {
                this.imageData.identify_card = URL.createObjectURL(file.raw)
                this.imageListPreview.identify_card = []
                this.imageListPreview.identify_card.push(URL.createObjectURL(file.raw))
                let param = {
                    path: `regular_customer_register/${this.data.shopDetail.userId}/identify_card`,
                    file: file,
                    type: 'identify_card'
                }
                let result = await this.getCollectionLastData(param)
                result.path = param.path
                let paramUpload = {
                    imageData: file,
                    collection: result
                }
                this.$set(this.data.imageDetail.imageUpload, 'identify_card', paramUpload)
            } else {
                this.$message({
                    message: 'picture must be (jpeg, jpg, png, gif, bmp) format!',
                    type: 'warning'
                })
            }
        },
        async uploadBookBank (file) {
            var allowImageType = ['image/jpeg', 'image/jpg', 'image/png', 'image/gif', 'image/bmp']
            if (allowImageType.indexOf(file.raw.type) > -1) {
                this.imageData.bank_book_account = URL.createObjectURL(file.raw)
                this.imageListPreview.bank_book_account = []
                this.imageListPreview.bank_book_account.push(URL.createObjectURL(file.raw))
                let param = {
                    path: `regular_customer_register/${this.data.shopDetail.userId}/bank_book_account`,
                    file: file,
                    type: 'bank_book_account'
                }
                let result = await this.getCollectionLastData(param)
                result.path = param.path
                let paramUpload = {
                    imageData: file,
                    collection: result
                }
                this.$set(this.data.imageDetail.imageUpload, 'bank_book_account', paramUpload)
            } else {
                this.$message({
                    message: 'picture must be (jpeg, jpg, png, gif, bmp) format!',
                    type: 'warning'
                })
            }
        },
        async uploadVat (file) {
            var allowImageType = ['image/jpeg', 'image/jpg', 'image/png', 'image/gif', 'image/bmp']
            if (allowImageType.indexOf(file.raw.type) > -1) {
                this.imageData.vat_company = URL.createObjectURL(file.raw)
                this.imageListPreview.vat_company = []
                this.imageListPreview.vat_company.push(URL.createObjectURL(file.raw))
                let param = {
                    path: `regular_customer_register/${this.data.shopDetail.userId}/vat_company`,
                    file: file,
                    type: 'vat_company'
                }
                let result = await this.getCollectionLastData(param)
                result.path = param.path
                let paramUpload = {
                    imageData: file,
                    collection: result
                }
                this.$set(this.data.imageDetail.imageUpload, 'vat_company', paramUpload)
            } else {
                this.$message({
                    message: 'picture must be (jpeg, jpg, png, gif, bmp) format!',
                    type: 'warning'
                })
            }
        },
        async getUrlImage () {
            let loading = this.$loading({
                target: '.image-loading-shop-bank-info'
            })
            let loading1 = this.$loading({
                target: '.image-loading-shop-bank-info1'
            })
            let loading2 = this.$loading({
                target: '.image-loading-shop-bank-info2'
            })
            let imageList = {
                bank_book_account: [],
                identify_card: [],
                vat_company: []
            }
            let imageUrl = {
                bank_book_account: '',
                identify_card: '',
                vat_company: ''
            }
            let imageUrlPreview = {
                bank_book_account: [],
                identify_card: [],
                vat_company: []
            }
            const env = (mode) => {
                if (mode === 'production') {
                    return 'prod'
                } else {
                    return mode
                }
            }
            let storageRef = this.$store.get('fgFirbaseApp/' + env(this.$store.get('envSystem/mode'))).storage().ref()
            let directoryRef = await storageRef.child(`regular_customer_register/${this.data.shopDetail.userId}`)
            let listFolder = await directoryRef.listAll()
            for (const folderName of listFolder.prefixes) {
                let listItems = await folderName.listAll()
                for (const item of listItems.items) {
                    let itemRef = await storageRef.child(item.fullPath)
                    let metaitem = await itemRef.getMetadata()
                    imageList[folderName.name].push({
                        name: item.name,
                        metaItem: metaitem
                    })
                }
            }
            // sort by timeCreated
            // eslint-disable-next-line no-unused-vars
            for (let [key, value] of Object.entries(imageList)) {
                imageList[key].sort(function (a, b) {
                    var c = new Date(a.metaItem.timeCreated)
                    var d = new Date(b.metaItem.timeCreated)
                    return d - c
                })
                imageList[key] = imageList[key][0]
            }

            // get image url
            for (let [key, value] of Object.entries(imageList)) {
                if (value) {
                    let directoryRef = await storageRef.child(value.metaItem.fullPath)
                    let userProfileUrl = await directoryRef.getDownloadURL()
                    imageUrl[key] = userProfileUrl
                    imageUrlPreview[key].push(userProfileUrl)
                } else {
                    imageUrl[key] = 'http://www.mayline.com/products/images/product/noimage.jpg'
                }
            }
            this.$set(this.data.imageDetail, 'imageData', imageUrl)
            this.$set(this.data.imageDetail, 'imageListPreview', imageUrlPreview)
            this.$set(this.data.imageDetail, 'checkFetch', true)
            this.imageData = imageUrl
            this.imageListPreview = imageUrlPreview
            loading.close()
            loading1.close()
            loading2.close()
        },
        updateBankAddress (address) {
            this.data.shopDetail.bankAccountProvince = address.province
            this.data.shopDetail.bankAccountDistrict = address.district
            this.data.shopDetail.bankAccountSubDistrict = address.subDistrict
            this.data.shopDetail.bankAccountZipcode = address.zipcode

            // this.data.shopDetail.bankAccountProvince = address.name.province
            // this.data.shopDetail.bankAccountDistrict = address.name.district
            // this.data.shopDetail.bankAccountSubDistrict = address.name.subDistrict
            // this.data.shopDetail.bankAccountZipcode = address.name.zipcode
        }
    }
}
</script>

<style lang="scss">
.shop-bank-info-modal{
  .avatar-uploader .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
  }
  .avatar-uploader .el-upload:hover {
    border-color: #409EFF;
  }
  .avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 178px;
    height: 178px;
    line-height: 178px;
    text-align: center;
  }
  .avatar {
    border-radius: unset !important;
    width: 230px !important;
    height: 230px !important;
    display: block;
  }
//   .zipcode-system-bank{
//       padding-bottom: 12px;
//     .-square:nth-child(1){
//         padding: 12px 0px !important;
//     }
//     .-square:nth-child(3){
//         padding: 12px 0px !important;
//     }
//       .input{
//           width: 100% !important;
//         }
//         //   ._bordererror{
//         //       border: 1px solid #F56C6C !important;
//         //   }
//           .field{
//             color: #606266;
//             display: flex;
//             align-items: center;
//             .label{
//                 min-width: 99px!important;
//             }
//             .input{
//                 .field{
//                     // padding-left: 15px;
//                     border: 1px solid #DCDFE6;
//                 }
//             }
//           }
//         //   .field:focus{
//         //     border: 1px solid #26a69a !important;
//         //     outline:none;
//         //   }
//         //   .field:disabled{
//         //     background-color: #F5F7FA !important;
//         //   }
//         //   .errormessage{
//         //       color: #F56C6C !important;
//         //   }
//           .icon{
//             font-size: 24px;
//             display: flex;
//             justify-content: center;
//             align-items: center;
//           }
//   }
}
</style>
